import { render, staticRenderFns } from "./AddExpense.vue?vue&type=template&id=dbd32386&scoped=true"
import script from "./AddExpense.vue?vue&type=script&lang=js"
export * from "./AddExpense.vue?vue&type=script&lang=js"
import style0 from "./AddExpense.vue?vue&type=style&index=0&id=dbd32386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd32386",
  null
  
)

export default component.exports